import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { InventoryOutputModel } from 'src/app/models/inventory/inventory-output.model';
import { InventoryOutputPrintModel } from 'src/app/models/print/inventory/inventory-output-print.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InventoryOutputService {

  constructor(private _httpClient: HttpClient) { }

  createInventoryOutput(inventoryOutputContract: InventoryOutputModel): Observable<InventoryOutputModel> {
    return this._httpClient.post<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutput.CreateInventoryOutput}`,
      inventoryOutputContract);
  }

  deleteAllBalances(inventoryOutputId: number): Observable<InventoryOutputModel> {
    return this._httpClient.delete<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutput.DeleteAllBalances}/${inventoryOutputId}`);
  }

  deleteInventoryOutput(inventoryOutputId: number): Observable<InventoryOutputModel> {
    return this._httpClient.delete<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutput.DeleteInventoryOutput}/${inventoryOutputId}`);
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutput.ExportGeneralConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  getAllClientsForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutput.GetAllClientsForSelectAsync}`);
  }

  getAllConceptsForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutput.GetAllConceptsForSelectAsync}`);
  }

  getAllInventoriesForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutput.GetAllInventoriesForSelectAsync}`,);
  }

  getAllInventoryOutputTypesForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutput.GetAllInventoryOutputTypesForSelectAsync}`);
  }

  getAllInventoryOutputsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutput.GetAllInventoryOutputsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getBussinessDocumentsClassIdAsync(bussinessDocumentsTypeId: number): Observable<number> {
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutput.GetBussinessDocumentsClassIdAsync}/${bussinessDocumentsTypeId}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutput.GetColumnsForGeneralConsultationAsync}`);
  }

  getEmptyInventoryOutputPrint(): Observable<InventoryOutputPrintModel> {
    return this._httpClient.get<InventoryOutputPrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutput.GetEmptyInventoryOutputPrint}`);
  }

  getFirstInventoryOutputByKeysAsync(inventoryId: number, branchId: number, inventoryOutputTypeId: number): Observable<InventoryOutputModel> {
    return this._httpClient.get<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutput.GetFirstInventoryOutputByKeysAsync}/${inventoryId}/${branchId}/${inventoryOutputTypeId}`);
  }

  getInventoryOutputById(inventoryOutputId: number): Observable<InventoryOutputModel> {
    return this._httpClient.get<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutput.GetInventoryOutputById}/${inventoryOutputId}`);
  }

  getInventoryOutputByKeysAsync(inventoryId: number, branchId: number, inventoryOutputTypeId: number, consecutive: number): Observable<InventoryOutputModel> {
    return this._httpClient.get<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutput.GetInventoryOutputByKeysAsync}/${inventoryId}/${branchId}/${inventoryOutputTypeId}/${consecutive}`);
  }

  getInventoryOutputByKeysForPrintAsync(inventoryOutputId: number, inventoryId: number, branchId: number, inventoryOutputTypeId: number, consecutive: number): Observable<InventoryOutputPrintModel> {
    const params = new HttpParams().set('inventoryOutputId', inventoryOutputId).set('inventoryId', inventoryId).set('branchId', branchId).set('inventoryOutputTypeId', inventoryOutputTypeId).set('consecutive', consecutive);
    return this._httpClient.get<InventoryOutputPrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutput.GetInventoryOutputByKeysForPrintAsync}`,
      { params }
    );
  }

  getLastInventoryOutputByKeysAsync(inventoryId: number, branchId: number, inventoryOutputTypeId: number): Observable<InventoryOutputModel> {
    return this._httpClient.get<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutput.GetLastInventoryOutputByKeysAsync}/${inventoryId}/${branchId}/${inventoryOutputTypeId}`);
  }

  getNextInventoryOutputByKeysAsync(inventoryId: number, branchId: number, inventoryOutputTypeId: number, consecutive: number): Observable<InventoryOutputModel> {
    return this._httpClient.get<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutput.GetNextInventoryOutputByKeysAsync}/${inventoryId}/${branchId}/${inventoryOutputTypeId}/${consecutive}`);
  }

  getPermissionPrint(): Observable<boolean> {
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutput.GetPermissionPrint}`);
  }

  getPreviusInventoryOutputByKeysAsync(inventoryId: number, branchId: number, inventoryOutputTypeId: number, consecutive: number): Observable<InventoryOutputModel> {
    return this._httpClient.get<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutput.GetPreviusInventoryOutputByKeysAsync}/${inventoryId}/${branchId}/${inventoryOutputTypeId}/${consecutive}`);
  }

  setInventoryOutputState(inventoryOutputId: number): Observable<InventoryOutputModel> {
    return this._httpClient.put<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutput.SetInventoryOutputState}/${inventoryOutputId}`,
      null);
  }

  updateInventoryOutput(inventoryOutputContract: InventoryOutputModel): Observable<InventoryOutputModel> {
    return this._httpClient.put<InventoryOutputModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutput.UpdateInventoryOutput}`,
      inventoryOutputContract);
  }
}
